// Componente Lin-renovar-poliza.vue
<template>
  <div class="animated fadeIn">
    <br>
    <b-row>
      <b-col lg="12">
        <b-card>
          <b-row>
            <b-col lg="6"> </b-col>
            <b-col lg="6">
              <b-form-group label label-for="filtroProceso">
                <b-form-input
                  id="filtroProceso"
                  type="text"
                  placeholder="Filtrar"
                  v-model="filters[0].value"
                  size="sm"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="12">
              <div ref="refTable">
                <data-tables
                  ref="refTableData"
                  :data="datalinrenovarpol"
                  name="table"
                  class="table-responsive"
                  :current-page.sync="pagina"
                  :table-props="tableProps"
                  :filters="filters"
                  :page-size="10"
                  :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
                  layout="table"
                  >
                  <el-table-column
                    v-for="title in titles"
                    :min-width="title.minwidth"
                    :prop="title.prop"
                    :label="title.label"
                    :key="title.label"
                    :align="title.align"
                    :formatter="formatter"
                    sortable="custom"
                    name="table"
                    class="table-responsive"
                    >
                  </el-table-column>
                </data-tables>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>  
    </b-row>  

    <b-alert 
      dismissible
      :variant="variant"
      v-model="showAlert"
      >
      <p>{{ mensaje }} </p>
      
    </b-alert>

  </div>

</template>
    
<script>

import { Switch as cSwitch } from "@coreui/vue";
import axios from "axios";
import { tablasMixin } from "@/components/mixins/tablasMixin";
import apiConsultaCliente from "@/components/services/apiConsultaCliente";
import { globalesMixin } from "@/components/mixins/globalesMixin";
import { utilesMixin } from "@/components/mixins/utilesMixin";
import Datepicker from "vuejs-datepicker";
import { es } from "vuejs-datepicker/dist/locale";
import moment from 'moment';
import download from "downloadjs";
import Multiselect from 'vue-multiselect';


export default {
  name: "Lin-renovar-poliza",
  mixins: [tablasMixin, globalesMixin, utilesMixin],
  props: {
    // title: { type: String },
    poliza: String,
    fedesde: Datepicker,
    fehasta: Datepicker,
    rechazos: String,
    expiradas: String,
    // timeOnSite: { type: Number, required: true }
  },

  data: function() {
    return {
      datalinrenovarpol:[],
      busqueda: "",
      pagina: 1,
      paginaAnterior: 1,
      showAlert: false,
      
      variant: "",
      mensaje: "",
      tableProps: {
        // summaryMethod: this.totales,
        showSummary: false,
        maxHeight: 400,
      },
      
      titles: [
        {
          prop: "cliente",
          label: "Nombre Cliente",
          align: "left",
          minwidth:'250'
        },
        {
          prop: "rut",
          label: "Rut",
          align: "center",
          minwidth:'100'
        },      
        {
          prop: "direccion",
          label: "Dirección",
          align: "left",
          minwidth:'200'
        },      
        {
          prop: "ciudad",
          label: "Ciudad",
          align: "center",
          minwidth:'100'
        },      
        {
          prop: "ms",
          label: "M/S",
          align: "center",
          minwidth:'100'
        },      
        {
          prop: "moneda",
          label: "Moneda",
          align: "center",
          minwidth:'100'
        },  
        {
          prop: "mtosolicitado",
          label: "Monto Solicitado",
          align: "right",
          minwidth:'100'
        },      
        {
          prop: "mtoaprobado",
          label: "Monto Aprobado",
          align: "right",
          minwidth:'100'
        },      
        {
          prop: "monedapol",
          label: "Mon. Póliza",
          align: "center",
          minwidth:'100'
        },  
        {
          prop: "mtosolicitadopol",
          label: "Monto Solicitado Pol.",
          align: "right",
          minwidth:'100'
        },      
        {
          prop: "mtoaprobadopol",
          label: "Monto Aprobado Pol.",
          align: "right",
          minwidth:'100'
        },      

        {
          prop: "mtovig",
          label: "Monto Vigente",
          align: "right",
          minwidth:'100'
        },      
        {
          prop: "venta12",
          label: "Ventas 12 meses",
          align: "center",
          minwidth:'80'
        },      
        {
          prop: "linestado",
          label: "Estado",
          align: "center",
          minwidth:'80'
        },      
        {
          prop: "linvigdesde",
          label: "Fecha desde",
          align: "center",
          minwidth:'80'
        },      
        {
          prop: "linvighasta",
          label: "Fecha hasta",
          align: "center",
          minwidth:'80'
        },      
        {
          prop: "ansfrecepcion",
          label: "Fec.Solic",
          align: "center",
          minwidth:'80'
        },      
        {
          prop: "ansfresolucion",
          label: "Fec.Resol",
          align: "center",
          minwidth:'80'
        },      
        {
          prop: "annaplazo",
          label: "Plazo",
          align: "center",
          minwidth:'80'
        },      
        {
          prop: "linpagador",
          label: "Pagador",
          align: "left",
          minwidth:'150'
        },
        {
          prop: "carac",
          label: "Documento",
          align: "left",
          minwidth:'150'
        },
        {
          prop: "ansobservacion",
          label: "Observación Interna",
          align: "left",
          minwidth:'150'
        },
        {
          prop: "ansobsexterna",
          label: "Observación Externa",
          align: "left",
          minwidth:'150'
        },
        {
          prop: "anncostoestud",
          label: "Costo Est",
          align: "left",
          minwidth:'100'
        }
      ],

      filters: [
        {
          value: '',
          filterFn: (row, filter) => {
            return Object.keys(row).some(prop => {
              
              return row[prop].toString().toLowerCase().indexOf(filter.value.toLowerCase()) > -1
            })
            
          }
        }
      ],

    }
  },
  methods: {

    formatter(row, column) {
          if ((column.property == "fecha"
              ) && row[column.property]) {
            return this.configurarFechaLat(this.convierteFecha(row[column.property]));
          } else if ((column.property == "MONTOFINIQUITO") && row[column.property]) {
            if (row[column.property] == 0 || row[column.property] == "0") {
              return row[column.property];
            } else {
              return this.$numeral(row[column.property]).format("0,0.00");
            }
          } else {
            return row[column.property];
          }
    },

    recuperar_linrenovarpol() {
      this.$Progress.start(); 
            
        return apiConsultaCliente
          .recuperar_linrenovarpol(
            this.$session.get("mail"),
            this.$session.get("usuarioInterno"),
            this.poliza,
            this.fedesde, 
            this.fehasta,
            this.rechazos,
            this.expiradas
          )  
          .then(response => {
                
            response.data = this.keysMinuscula(response.data);
            this.datalinrenovarpol = response.data.res;

            this.$Progress.finish();
          })
          .catch(error => {
            this.mensaje= "Error";
            this.variant="warning";
            this.showAlert = true;
            this.$Progress.finish();
          });
    },
    
    // recuperar_siniestro() {
    //   this.$Progress.start(); 
    //   return apiConsultaCliente
    //     .recuperar_siniestro(
    //       this.$session.get("mail"),
    //       this.$session.get("usuarioInterno"),
    //       this.cod_asegurado,
    //       this.participacion
    //       )  
    //       .then(response => {
    //         response.data = this.keysMinuscula(response.data);
    //         this.datasiniestro = response.data.res;
    //         this.$Progress.finish();
    //       })
    //       .catch(error => {
    //         this.mensaje= error;
    //         this.variant="warning";
    //         this.showAlert = true;
    //         this.$Progress.finish();
    //       });
    // },
        
  },
      
  mounted() {
    // this.pagina = Number(this.$route.query.pagina);
    this.recuperar_linrenovarpol();
  },
  watch: {
    pagina: function(nuevo, anterior) {
      this.paginaAnterior = anterior;
    },
    
  }      
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>    
<style>
  .card-header {
      background-color: #00A7D4;
      color: #fff;
  }

  .multiselect__tag {
    background: #20a8d8 !important;
  }
  .multiselect__option--highlight:after {
    background: #20a8d8 !important;
  }

  .multiselect__option--highlight {
    background: #20a8d8 !important;
}
.multiselect__tags {
    border-radius: 0px !important;
    min-height: 70px !important;
}

.el-button {
    background: #00A7D4;
}
</style>